export default __webpack_public_path__ + "static/media/record-a-video.5ac76352.svg";